import { StoredAnestheticProtocol } from "duck";
import { MedicationCalculationTypeEnum, RegionalBlockTypeEnum } from "requests";

export const getMeds = (protocol: StoredAnestheticProtocol) => {
  const preAnestheticMeds =
    protocol.medicationCalculations?.collection.filter(
      medication =>
        medication.type === MedicationCalculationTypeEnum.PreAnesthetic
    ) || [];
  const inductionMeds =
    protocol.medicationCalculations?.collection.filter(
      medication => medication.type === MedicationCalculationTypeEnum.Induction
    ) || [];
  const additionalMeds =
    protocol.medicationCalculations?.collection.filter(
      medication => medication.type === MedicationCalculationTypeEnum.Additional
    ) || [];
  const epiduralCalc =
    protocol.regionalBlocks?.collection.filter(
      block => block.type === RegionalBlockTypeEnum.EpiduralCalculations
    ) || [];
  const regionalOralBlocks =
    protocol.regionalBlocks?.collection.filter(
      block => block.type === RegionalBlockTypeEnum.RegionalOralBlocks
    ) || [];

  return {
    preAnestheticMeds,
    inductionMeds,
    additionalMeds,
    epiduralCalc,
    regionalOralBlocks
  };
};
